import {  } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import FeaturesSection from "./Features";
import { motion } from 'framer-motion';
import Footer from "../../Component/Fooder";

const HTI = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* <div className="p-8  bg-gradient-to-t from-[#78ffa5] to-[#03ab3b]   w-full"> */}
      <div className="p-8  bg-white   w-full">
        {/* <h1 className=" mt-3 font-bold  text-white text-center mb-4 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"></h1> */}
        <motion.div
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="px-6 mb-2 text-center text-[30px] font-bold text-gray-800 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"
        >
         HikeHealth GS – Interoperability Solutions
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Feature 1 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
            {/* <FaRegHospital className="text-blue-500 text-3xl mb-3" /> */}
            <h2 className="text-center font-bold">Digital Health Startups</h2>
            <p className="text-gray-600 text-xs  mt-2">
            Supporting early-stage health tech companies with software development, integration, and scaling solutions to drive innovation in healthcare.
            </p>
            <div className="-mb-12">
              <button
                onClick={() => navigate('/Services/InteroperabilitySolutions/Digitalhealthstartup')}
                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
                Read More
              </button>
            </div>

          </div>

          {/* Feature 2 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
            {/* <FaShieldAlt className="text-green-500 text-4xl mb-2" /> */}
            <h2 className="text-lg font-bold">AI&Machine Learning in Healthcare</h2>
            <p className="text-gray-600 text-xs  mt-2">
            Leveraging AI-powered diagnostics, predictive analytics, and automated workflows to transform healthcare delivery and decision-making.
            </p>
            <div className="-mb-12">
 
              <button onClick={() => navigate('/Services/InteroperabilitySolutions/AI')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold"> Telehealth & Remote Patient Monitoring</h2>
            <p className="text-gray-600 text-xs mt-2">
            Providing solutions for virtual consultations, real-time patient tracking, and digital therapeutics to enhance access to care and improve patient monitoring.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/InteroperabilitySolutions/Telehealth')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Feature 4 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold"> Electronic Health Records (EHR) & Health IT</h2>
            <p className="text-gray-600 text-xs  mt-2">
            Cloud-based EHR solutions that enhance patient data management and ensure compliance with interoperability standards for seamless data exchange.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/InteroperabilitySolutions/EHR')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Feature 5 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold">Biotech & Medical Devices</h2>
            <p className="text-gray-600 text-xs  mt-2">
            Innovating next-gen drug discovery, CRISPR gene editing, and lab automation to accelerate breakthroughs in biotech and medical devices.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/InteroperabilitySolutions/Biotech')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Feature 6 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold">Blockchain & Cybersecurity in Healthcare</h2>
            <p className="text-gray-600 text-xs  mt-2">
            Implementing secure blockchain solutions for medical record storage and fraud prevention, ensuring privacy and data integrity.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/InteroperabilitySolutions/Blockchain')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Feature 7 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold">Personalized Medicine & Genomics</h2>
            <p className="text-gray-600 text-xs  mt-2">
            AI-driven drug discovery, computational biology, and genomic research solutions that enable personalized healthcare for better patient outcomes.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/InteroperabilitySolutions/PMG')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Feature 8 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold">Healthcare Venture Capital & Private Equity</h2>
            <p className="text-gray-600 text-xs  mt-2">
            Investing in healthcare funds, accelerators, and incubators to promote the growth of innovative solutions in the healthcare sector.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/InteroperabilitySolutions/HVC')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Feature 9 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold"> Regenerative Medicine & Stem Cell Therapy</h2>
            <p className="text-gray-600 text-xs  mt-2">
            Offering innovative stem cell-based treatments for chronic diseases, advancing the field of regenerative medicine.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/InteroperabilitySolutions/RMSCT')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>

         
        </div>


        <div><FeaturesSection /></div>
      </div>
      <Footer />
    </>
  );
};

export default HTI;
